<template>
    <div id="Calculator" class="container rounded">
        <div class="row rounded-top">
        <div class="col">
            {{ translate.inputtext }}
            </div>
        <div class="col input-group mb-1">
            <input class="form-control"
             v-model="mass" type="text" :placeholder="translate.peryear" />
            </div>
        </div>
        <div class="row"><div class="col">{{ translate.requerments }}</div></div>
        <div class="row"><div class="col">{{ result[14] }}</div></div>
        <div class="row">
        <div class="col">{{ translate.resource }}</div>
        <div class="col">{{ translate.count }}</div>
        <div class="col">{{ translate.sum }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.size }}</div>
        <div class="col">{{ Math.round(result[1]) }} га</div>
        <div class="col">{{ Math.round(result[7]) }}тг, ${{ Math.round(result[18]) }}
            <div class="row">
                <div class="col">{{ translate.with }}</div>
        </div></div>
        </div>
        <div class="row"><div class="col">{{ translate.firstpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.ship }}</div>
        <div class="col">{{ result[2] }} {{ translate.pieces }}</div>
        <div class="col">{{ result[8] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.fishitems }}</div>
        <div class="col">{{ result[3] }} {{ translate.parts }}</div>
        <div class="col">{{ result[9] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.currentpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.fishplant }}</div>
        <div class="col">{{ result[4] }} {{ translate.mlnlavra }}</div>
        <div class="col">{{ result[10] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.comsumabllematerial }}</div>
        <div class="col">{{ result[5] }} {{ translate.parts }}</div>
        <div class="col">{{ result[11] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.economic }}</div></div>
        <div class="row">
        <div class="col">{{ translate.revenue }}</div>
        <div class="col">{{ result[6] }} {{ getExchangeRate() }}</div>
        <div class="col">{{ result[12] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.gross }}</div>
        <div class="col">{{ translate.totalcost }}</div>
        <div class="col">{{ result[13] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.comment }}</div>
        </div>
        <div class="row rounded-bottom"><div class="col">{{ regionText }}</div></div>
        </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      ru: {
        inputtext: 'Введите планируемый объем производства рыб',
        peryear: 'тонн в год',
        requerments: 'Необходимые условия',
        resource: 'Показатель',
        count: 'Количество',
        sum: 'Сумма, тенге',
        size: 'Площадь водоема',
        with: 'из них',
        firstpay: 'Первоначальные затраты',
        ship: 'Лодка резиновая',
        pieces: 'шт.',
        fishitems: 'Рыболовный инвентарь',
        parts: 'комплект.',
        currentpay: 'Текущие затраты',
        fisheat: 'Корма',
        watt: 'Электропотребление',
        fishplant: 'Рыбопосадочный материал',
        economic: 'Экономические расчеты',
        gross: 'Прибыль',
        pertonn: 'тонн по 600 тг/кг',
        revenue: 'Выручка',
        totalcost: 'При себестоимости производства 25%',
        comment: 'Рекомендации по производству рыбной продукции',
        text: '«При планировании прудового хозяйства следует учитывать необходимость проведения земляных работ для улучшения состояния прудов и эффективной работы хозяйства, а также проведение мелиорации для улучшения кормовой базы»',
        aquasize: 'Площадь водной поверхности',
        numbersadkov: 'Количество садков',
        piecesfry: 'шт. молоди',
        trout: '«Для нормального функционирования форелевого садкового хозяйства необходим рыбохозяйственный участок с оптимальным температурным режимом для форели, не превышающий в летний период 18-20 °С»',
        sturgeon: '«Для нормального функционирования осетрового садкового хозяйства необходим рыбохозяйственный участок с оптимальным температурным режимом для осетра. Учитывая донный образ жизни осетровых необходимо использовать садки с глубиной не более 1,8 – 2,5 м»',
        carp: '«При выращивании карпа в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',
        mlnlavra: 'млн. личинок',
        comsumabllematerial: 'Расходные материалы',
        peled: '«При выращивании пеляди в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы. Также следует учесть высокий потенциал пеляди при однолетнем нагуле на заморных водоемах»',
        silvercarp: '«При выращивании толстолобика в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',
        whiteamur: '«При выращивании белого амура в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',

      },
      kz: {
        inputtext: 'Жоспар бойынша өндірілетін балық мөлшерін жазыңыз',
        peryear: 'жылына тонна',
        requerments: 'Қажетті жағдай',
        resource: 'Көрсеткіш',
        count: 'Саны',
        sum: 'Сомасы, теңге',
        size: 'Су айдынының ауданы',
        with: 'оның ішінде',
        firstpay: 'Алғашқы шығындар',
        ship: 'Резеңке қайық',
        pieces: 'дана.',
        fishitems: 'Балық аулайтын құрал-жабдық',
        parts: 'жиынтық',
        currentpay: 'Ағымды шығымдар',
        fisheat: 'Жемдер',
        watt: 'Электр қуатып пайдалану',
        fishplant: 'Отырғызылатын балық материалы',
        economic: 'Экономикалық есептер',
        gross: 'Пайда',
        pertonn: 'тонна 600 тг/кг бойынша',
        revenue: 'Табыс',
        totalcost: 'Өндірістің өзіндік құны 25% болғанда',
        comment: 'Балық өнімін өндіру барысындағы ұсыныстар',
        text: 'Тоған шаруашылығын жоспарлау барысында, шаруашылық жұмысының тиімділігін арттыру үшін және тоғандардың күйін жақсарту үшін жерде жасалатын жұмыстарды орындау қажет, қоректік базаны жақсарту үшін мелиорациялық жұмыстарды жүргізу керек.',
        aquasize: 'Су бетінің  ауданы',
        numbersadkov: 'Шарбақтар саны',
        piecesfry: 'дана. шабақтар',
        trout: 'Бахтақ балығын өсіретін шарбақ шаруашылықтын қалыпты жұмыс істуі үшін, ондағы су температура бахтах балығына  қолайлы болуы керек және жаз айларында 18-20 °С аспауы керек.',
        sturgeon: 'Бекіре балығын өсіретін шарбақ шаруашылығының қалыпты жұмыс істеуі үшін, бекіре балығының өсіп - өнуіне су температурасы қолайлы орта  қажет. Бекіре тұқымдас балықтардың су түбінде мекен ететіндігін ескере отырып, оларды өсіретін шарбақтардың тереңдігін 1,8',
        carp: 'Тұқы балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
        mlnlavra: 'слн. Дернәсіл',
        comsumabllematerial: 'Шығыс материалдары',
        peled: 'Ақсаха балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек. Сонымен қатар  оттегі тапшы су айдындарында ақсаха балығын бір жаздық жайылымдарда өсірудің жоғары потенциалы бар екендігін де ескеру қажет',
        silvercarp: 'Дөңмаңдай балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
        whiteamur: 'Ақ амурды КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
      },
      mass: null,
      result: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: '',
        15: 'ссылка на соответствующую область Казахстана',
        16: 0,
        17: 0,
        18: 0,
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    mass(newMass, oldMass) {
      const lang = this.$store.state.calc.currentLocale;
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      switch (true) {
        case (aquacultureObject === '25.ogg' && newMass < 50):
          this.result = {
            1: 4 * newMass,
            2: 2,
            3: 1,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 170000 + 250000 + (newMass * 40000) + (newMass * 7500),
            8: 170000,
            9: 250000,
            10: newMass * 40000,
            11: newMass * 7500,
            12: newMass * 1000000,
            13: newMass * 1000000 * 0.75,
            14: this[lang].peled,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (170000 + 250000 + (newMass * 40000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '25.ogg' && newMass < 100):
          this.result = {
            1: 4 * newMass,
            2: 4,
            3: 2,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 340000 + 500000 + (newMass * 40000) + (newMass * 7500),
            8: 340000,
            9: 500000,
            10: newMass * 40000,
            11: newMass * 7500,
            12: newMass * 1000000,
            13: newMass * 1000000 * 0.75,
            14: this[lang].peled,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (340000 + 500000 + (newMass * 40000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '25.ogg' && newMass > 100):
          this.result = {
            1: 4 * newMass,
            2: 6,
            3: 4,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 510000 + 1000000 + (newMass * 40000) + (newMass * 7500),
            8: 510000,
            9: 1000000,
            10: newMass * 40000,
            11: newMass * 7500,
            12: newMass * 1000000,
            13: newMass * 1000000 * 0.75,
            14: this[lang].peled,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (510000 + 1000000 + (newMass * 40000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '31.ogg' && newMass < 50):
          this.result = {
            1: 4 * newMass,
            2: 2,
            3: 1,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 170000 + 250000 + (newMass * 20000) + (newMass * 7500),
            8: 170000,
            9: 250000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].silvercarp,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (170000 + 250000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '31.ogg' && newMass < 100):
          this.result = {
            1: 4 * newMass,
            2: 4,
            3: 2,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 340000 + 500000 + (newMass * 20000) + (newMass * 7500),
            8: 340000,
            9: 500000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].silvercarp,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (340000 + 500000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '31.ogg' && newMass > 100):
          this.result = {
            1: 4 * newMass,
            2: 6,
            3: 4,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 510000 + 1000000 + (newMass * 20000) + (newMass * 7500),
            8: 510000,
            9: 1000000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].silvercarp,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (510000 + 1000000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '30.ogg' && newMass < 50):
          this.result = {
            1: 4 * newMass,
            2: 2,
            3: 1,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 170000 + 250000 + (newMass * 20000) + (newMass * 7500),
            8: 170000,
            9: 250000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].whiteamur,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (170000 + 250000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '30.ogg' && newMass < 100):
          this.result = {
            1: 4 * newMass,
            2: 4,
            3: 2,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 340000 + 500000 + (newMass * 20000) + (newMass * 7500),
            8: 340000,
            9: 500000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].whiteamur,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (340000 + 500000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '30.ogg' && newMass > 100):
          this.result = {
            1: 4 * newMass,
            2: 6,
            3: 4,
            4: 20000 * newMass,
            5: 1,
            6: newMass,
            7: 510000 + 1000000 + (newMass * 20000) + (newMass * 7500),
            8: 510000,
            9: 1000000,
            10: newMass * 20000,
            11: newMass * 7500,
            12: newMass * 600000,
            13: newMass * 600000 * 0.75,
            14: this[lang].whiteamur,
            15: 'ссылка на соответствующую область Казахстана',
            16: 0,
            17: 0,
            18: (510000 + 1000000 + (newMass * 20000) + (newMass * 7500))
             / this.getUSD(),
          };
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.getCurrency();
    this.$say('4.ogg');
  },
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },
    regionText() {
      const lang = this.$store.state.calc.currentLocale;
      const region = this.$store.state.calc.selectedRegion;
      return this.$store.state.calc.textRegion[lang][region];
    },
  },
  methods: {
    ...mapActions('calc', ['getCurrency']),
    translateTonn(item) {
      const lang = this.$store.state.calc.currentLocale;
      if (lang === 'ru') {
        return `тонн по ${item} тг/кг`;
      }
      return `тонна ${item} тг/кг бойынша`;
    },
    getExchangeRate() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      let result;
      if (aquacultureObject === '25.ogg') {
        result = this.translateTonn(1000);
      }
      if (aquacultureObject === '31.ogg') {
        result = this.translateTonn(600);
      }
      if (aquacultureObject === '30.ogg') {
        result = this.translateTonn(600);
      }
      return result;
    },
    getGross() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      if (aquacultureObject === 'Карп') {
        return '25%';
      }
      return '40%';
    },
    getMeasure() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      if (aquacultureObject === 'Карп') {
        return 'га';
      }
      return 'м²';
    },
    getUSD() {
      return this.$store.state.calc.USD;
    },
    round_to_precision(x, precision) {
      const y = +x + (precision === undefined ? 0.5 : precision / 2);
      return y - (y % (precision === undefined ? 1 : +precision));
    },
  },


};
</script>
<style scoped>
#Calculator {
    background-color: #22a6de;
    margin: 0 auto;
}
#Calculator div.row {
    border-top: solid #bababa 1px;
    text-align: center;
}
#Calculator div.col {
    border-left: solid #bababa 1px;
    text-align: center;
}
.row {
  flex-wrap: nowrap !important;
}
</style>
